import { render, staticRenderFns } from "./communication-textual-filters.vue?vue&type=template&id=39296c5f"
import script from "./communication-textual-filters.vue?vue&type=script&lang=js"
export * from "./communication-textual-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports